/**
 * This const exports a list (Array) of pension field names that are set by a pension template.
 */
const templateFieldNames = ['contributionsSelfPaid', 'contributionsFrequency', 'contributionsDeductible', 'payoutsTaxable', 'payoutsIndexed', 'payoutsFrequency', 'payoutsDuration'];

export default templateFieldNames;
